import { Link } from "react-router-dom";
import { EnvelopeSimple, FacebookLogo, InstagramLogo, TiktokLogo } from "@phosphor-icons/react";
import { useSite, useSiteLang } from "@/hooks/useSite";
import LanguagePicker from "@/components/LanguagePicker";
import { StoreButtons, Wordmark } from "@/components/site/SiteBits";

const COLS = [
  [["/", "Home"], ["/how-it-works", "How it works"], ["/plans", "Plans"], ["/safety", "Safety"], ["/faq", "FAQ"]],
  [["/terms", "Terms"], ["/privacy", "Privacy"], ["/guidelines", "Community guidelines"], ["/support", "Support"]],
];
const linkCls = "s-muted s-focus rounded transition-colors hover:text-[var(--s-text)]";

function Contacts({ s, links }) {
  const rows = [
    s.email && [`mailto:${s.email}`, EnvelopeSimple, s.email, "email"],
    links.instagram && [links.instagram, InstagramLogo, s.instagram || "Instagram", "instagram"],
    links.facebook && [links.facebook, FacebookLogo, s.facebook || "Facebook", "facebook"],
    links.tiktok && [links.tiktok, TiktokLogo, s.tiktok || "TikTok", "tiktok"],
  ].filter(Boolean);
  return (
    <ul className="space-y-3 text-sm" data-testid="site-footer-social">
      {rows.map(([href, Icon, label, k]) => (
        <li key={k}><a href={href} {...(k === "email" ? {} : { target: "_blank", rel: "noreferrer" })} className={`${linkCls} inline-flex items-center gap-2.5`} data-testid={`site-footer-${k}`}>
          <Icon size={18} aria-hidden />{label}</a></li>
      ))}
    </ul>
  );
}

export default function SiteFooter() {
  const { data } = useSite();
  const { lang, languages, setLang } = useSiteLang();
  const s = data?.social || {};
  return (
    <footer className="mt-8 border-t s-line" data-testid="site-footer">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 sm:px-8 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
        <div>
          <Link to="/" aria-label="Crushwink home" className="s-focus inline-block rounded-lg" data-testid="site-footer-logo-link"><Wordmark testId="site-footer-logo" /></Link>
          {data?.tagline && <p className="s-muted mt-4 text-sm" data-testid="site-footer-tagline">{data.tagline}</p>}
          <StoreButtons stores={data?.stores} className="mt-6" testId="site-footer-stores" />
        </div>
        {COLS.map((col, i) => (
          <nav key={i} aria-label={i ? "Legal and support" : "Site"}>
            <ul className="space-y-3 text-sm">{col.map(([to, l]) => <li key={to}><Link to={to} className={linkCls} data-testid={`site-footer-link-${to.slice(1) || "home"}`}>{l}</Link></li>)}</ul>
          </nav>
        ))}
        <div>
          <Contacts s={s} links={data?.social_links || {}} />
          {s.press_line && <p className="s-muted mt-5 text-sm" data-testid="site-footer-press">{s.press_line}</p>}
        </div>
      </div>
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 border-t s-line px-5 py-6 sm:px-8">
        {s.copyright ? <p className="s-muted text-xs" data-testid="site-footer-copyright">{s.copyright}</p> : <span />}
        <LanguagePicker value={lang} languages={languages} onChange={setLang} side="top" testId="site-footer-language" />
      </div>
    </footer>
  );
}
